import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Pagination } from '@mui/material';

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
});

const StyledPagination = styled(Pagination)({
  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium': {
    background: '#4AB3BC',
    border: 'none',
    height: '24px',
    minWidth: '24px',
  },
  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium.Mui-selected': {
    background: '#4AB3BC',
    color: '#fff',
  },
  '& .MuiPaginationItem-icon': {
    color: '#fff',
  },
});

const CommonPagination = ({ totalElements, limit, page, onChange, ...rest }) => {
  const count = Math.ceil((totalElements || 0) / (limit || 1));
  if (count <= 0) return null;

  return (
    <Wrapper>
      <StyledPagination
        count={count}
        page={page}
        onChange={onChange}
        variant="outlined"
        shape="rounded"
        {...rest}
      />
    </Wrapper>
  );
};

export default CommonPagination;
